import { library } from '@fortawesome/fontawesome-svg-core'
import { fab, faGit, faTwitter, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faCoffee } from '@fortawesome/free-solid-svg-icons'

library.add(fab, faTwitter, faLinkedin, faGit,faEnvelope)